import { render } from "./AdminSessions.vue?vue&type=template&id=a2371928&scoped=true"
import script from "./AdminSessions.vue?vue&type=script&lang=js"
export * from "./AdminSessions.vue?vue&type=script&lang=js"

import "./AdminSessions.vue?vue&type=style&index=0&id=a2371928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2371928"]])

export default __exports__